// var totalSlides = $('#ourServicesIconSlider > .slick-slide').length;
var totalSlides = document.querySelectorAll('#ourServicesIconSlider .card').length;
jQuery('#ourServicesIconSlider').slick({
    slidesToShow: (totalSlides >= 5) ? 4.3 : totalSlides,
    slidesToScroll: 1,
    autoplay: false,
    arrows: true,
    // centerMode: true,
    // centerPadding: '50px',
    infinite: false,
    prevArrow: jQuery(".our-services-icon-slider-prev"),
    nextArrow: jQuery(".our-services-icon-slider-next"),
    pauseOnHover: true,
    // focusOnSelect: true,
    pauseOnFocus: true,
    responsive: [
        {
            breakpoint: 1300,
            settings: {
                slidesToShow: (totalSlides >= 5) ? 4.3 : totalSlides,
            }
        },
        {
            breakpoint: 1000,
            settings: {
                slidesToShow: (totalSlides >= 3) ? 3 : totalSlides,
            }
        },
        {
            breakpoint: 678,
            settings: {
                slidesToShow: (totalSlides >= 2) ? 2 : totalSlides,
            }
        },
        {
            breakpoint: 520,
            settings: {
                slidesToShow: 1,
            }
        }
    ]
});